
import { defineComponent, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMedia } from '@/utils/useMedia'
import { getUser, useEvent } from '@coderhouse/common'
import { getMainJourney } from '@/api/new-suggested-courses.api'

export default defineComponent({
  props: {},
  setup(props) {
    const { t } = useI18n()
    const isDesktop = useMedia('(min-width: 1280px)')
    const isMediumDesktop = useMedia('(min-width: 768px)')
    const journey = ref()
    const link = t('home.my-journey.empty-journey-subtitle')

    onMounted(async () => {
      journey.value = await getMainJourney()
    })

    return {
      t,
      isDesktop,
      isMediumDesktop,
      journey,
      link
    }
  }
})
